/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileFollowButton_viewer = {
    readonly user?: {
        readonly favorites: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly serviceId: string | null;
                    readonly anchor: {
                        readonly sourceId: string | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly tradeFirms: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly name: string | null;
        readonly publicProfile: {
            readonly urlLabel: string | null;
        } | null;
    } | null> | null;
    readonly " $refType": "ProfileFollowButton_viewer";
};
export type ProfileFollowButton_viewer$data = ProfileFollowButton_viewer;
export type ProfileFollowButton_viewer$key = {
    readonly " $data"?: ProfileFollowButton_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileFollowButton_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ProfileFollowButton_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirms",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "urlLabel",
          "variableName": "firmUrlLabel"
        }
      ],
      "concreteType": "TradeFirmType",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "publicProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmPublicProfileType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "favorites",
              "storageKey": "favorites(types:[\"DESIGNER\"])",
              "args": [
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "DESIGNER"
                  ]
                }
              ],
              "concreteType": "favoritesConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "favoritesEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Favorite",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "anchor",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Anchor",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "sourceId",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '989f3d73f554e899bfd5f4e1181f018b';
export default node;
